import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=0b1c93e0&scoped=true&"
import script from "./desktop.vue?vue&type=script&lang=ts&"
export * from "./desktop.vue?vue&type=script&lang=ts&"
import style0 from "./desktop.vue?vue&type=style&index=0&id=0b1c93e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c93e0",
  null
  
)

export default component.exports